import { Box, Card, Chip } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import DataTable from "../../../../Components/Table/DataTable";
import WDBox from "../../../../MaterialComponents/WDBox";
import AppService from "../../../../Configurations/Appservice";
import VisibilityOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import pxToRem from "../../../../Themes/Functions/pxToRem";

import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import InvoicePdf from "./panels/InvoicePdf";
import { updateScreenTitle } from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import InvoicePrint from "./panels/InvoicePrint";

const tableInitialData = {
  columns: [
    { Header: "Invoice Number", accessor: "invoiceNumber" },
    { Header: "Date", accessor: "date" },
    { Header: "govtcharge", accessor: "govtcharge" },
    { Header: "servicecharge", accessor: "servicecharge" },
    { Header: "tax", accessor: "taxonservicecharge" },
    { Header: "fine", accessor: "fine" },
    { Header: "discount", accessor: "discount" },
    { Header: "Download", accessor: "view", width: "10%" },
    // { Header: "StatusSearch", accessor: "statusSearch", show: false },
  ],
  rows: [],
};

const tableFilters = [];

const hiddenColumns = ["statusSearch"];

const MyInvoices = () => {
  const [tableData, setTableData] = useState(tableInitialData);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Invoices"));
    return () => dispatch(updateScreenTitle());
  }, []);

  useEffect(() => {
    AppService.get("v1/invoice/myInvoices").then((response) => {
      _generateRows(response);
    });
  }, []);

  const _downloadInvoice = async (item) => {
    const params = { invoiceId: item.invoiceid };
    AppService.get("v1/invoice/invoiceDataModel", { params })
      .then((response) => {
        console.log(response);
        // const doc = <InvoicePdf data={response} />;
        const doc = <InvoicePrint data={response} />;
        const asPdf = pdf([]);
        asPdf.updateContainer(doc);
        asPdf.toBlob().then((blob) => {
          saveAs(blob, "Invoice_" + response.invoiceNumber);
        });
      })
      .catch((error) => {
        console.log(error);
        alert("error");
      })
      .finally(() => {});
  };

  const _generateRows = (data) => {
    let rows = data.map((item) => ({
      ...item,
      view: <DownloadIcon onClick={() => _downloadInvoice(item)} />,
    }));
    let tableDataCopy = { ...tableData };
    tableDataCopy.rows = rows;
    setTableData(tableDataCopy);
  };

  return (
    // <WDBox py={1}>
    //   <Card>
    //     {tableData.rows.length && (
    //       <DataTable table={tableData} hiddenColumns={hiddenColumns} tableFilters={tableFilters} />
    //     )}
    //   </Card>
    // </WDBox>
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* <Card sx={{ mb: 1, p: 2 }}>{_renderSearchBar()}</Card> */}
      {
        <DataTable
          table={tableData}
          // hiddenColumns={hiddenColumns}
          // showAddButton={true}
          // addButtonOnClick={() => {
          //   navigate("/ADM-Ticket/new-ticket");
          // }}
        />
      }
    </Box>
  );
};

export default MyInvoices;
